<template>
  <q-banner class="aeroflot-banner text-center text-black">
    <span
      v-html="$t(`domains.aeroflot.banner_heading_${aeroflotMilesCount}`)"
    />
    <q-btn
      class="q-ml-4"
      icon="info"
      size="12px"
      round
      flat
      padding="0"
      @click="$refs.aeroflotModalRef.show()"
    />
    <Modal
      ref="aeroflotModalRef"
      :title="$t('domains.aeroflot.modal_heading')"
    >
      <q-card class="q-px-md-16">
        <q-card-section
          v-for="(text, i) in promotionConditions"
          :key="i"
          class="q-pt-none"
        >
          <div v-html="text" />
        </q-card-section>
      </q-card>
    </Modal>
  </q-banner>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  inject,
} from 'vue';

import { useI18n } from 'vue-i18n';

import Modal from '~components/Modal';

import useAeroflotSpecialPromo from '~composables/useAeroflotSpecialPromo';

const { t, tm } = useI18n();

const { bonusDates, isBonusTime, aeroflotMilesCount } = useAeroflotSpecialPromo();

const bus = inject('bus');
const moment = inject('moment');

const aeroflotModalRef = ref(null);

const promotionConditions = computed(() => {
  const conditions = tm('domains.aeroflot.promotion_conditions');
  if (isBonusTime.value) {
    conditions.splice(1, 0, t('domains.aeroflot.promotion_conditions_bonus', {
      from: moment(bonusDates.from).format('LL'),
      to: moment(bonusDates.to).format('LL'),
      usual: moment('2023-07-01T00:00:00+0300').format('LL'),
    }));
  }
  return conditions;
});

onMounted(() => {
  bus.on('show-aeroflot-modal', () => {
    aeroflotModalRef.value.show();
  });
});

onBeforeUnmount(() => {
  bus.off('show-aeroflot-modal');
});
</script>
